import IconButton, { IconButtonProps } from './IconButton';

export default IconButton;
export { IconButtonProps };
